<template>
  <div v-if="blogs" class="industury">
    <div class="industury__topbanner">
      <ul v-if="$root.globalData">
        <li>{{$root.globalData.keys.blog_text}}</li>
        <span> <DoubleLeftAroow /> </span>
        <li>
          <router-link style="color: white" to="/"> {{$root.globalData.keys.home_index_text}} </router-link>
        </li>
      </ul>
    </div>
    <div class="responsive__filter__box"></div>

    <div id="industury__body" class="industury__body w95 margin">
      <div
        class="industury__rightbox"
        data-aos="fade-right"
        data-aos-duration="2000"
      >
        <!-- blog filter search  -->
        <div class="blog__filter">
          <div class="blog__search">
            <span> <SearchIconBlue /></span>
            <input @keydown.enter="filter()" v-model="search" type="text" placeholder=" جستجو " />
          </div>
        </div>
        <!-- end blog search  -->

        <!-- category list blog filter  -->

        <v-select
        :menu-props="{
          closeOnClick: true,
          closeOnContentClick: true
        }"
          v-if="categories"
          class="unitsFilter"
          v-model="selectedCategory"
          :items="categories"
          :label="
            $cookie.get('language') == 'en'
              ? 'select categories'
              : 'انتخاب دسته بندی'
          "
          item-text="name"
          item-value="id"
          prepend-icon="mdi-map"
          multiple
        >
        </v-select>
        <div id="filterButtonBox">
          <button @click="filter()">
            {{ $cookie.get("language") == "en" ? "Apply" : "فیلتر کردن" }}
          </button>
        </div>
        <!-- <div class="More__Blogs__Visited">
          <h4 class="visited__title">پربازدیدترین ها</h4>

          <div
            class="blog__visited__box"
            v-for="(item, index) in VisitedBlogBox"
            :key="index"
          >
            <img :src="blogVisitedImage" alt="blog image" />
            <div class="blog__desc">
              <p>{{ blogdesctext }}</p>
              <span> <ClockIcon /> {{ blogdate }} </span>
            </div>
          </div>
        </div> -->

        <!-- end category list blog filter  -->
      </div>
      <div class="industury__leftbox">
        <!-- <div class="industuty__setiing__responsive margin w">
          <div class="industury__btn__setting__responsive">
            <span v-on:click="showfilterbox = true" class="btn__setting"
              >فیلتر کردن <FilterIcon />
            </span>
            <span class="active" v-on:click="ShowingCard = false"
              ><MenuIcon1
            /></span>
            <span class="btn__setting">
              ترتیب نمایش <SortResponsiveIcon />
            </span>
          </div>
        </div> -->

        <div class="blogList">
          <Cardbox
            :data="item"
            class="card"
            v-for="(item, index) in blogs.data"
            :key="index"
          />
        </div>
        <section v-if="blogs.data != ''" class="pagination__section">
          <pagination
            :router="true"
            :limit="3"
            :data="blogs"
            @pagination-change-page="changePage"
            class="justify-content-center"
          >
            <span slot="prev-nav">
              <svg
                class="page-arrow mb-2"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="22"
                height="22"
                viewBox="0 0 226 226"
                style="fill: #000000"
              >
                <g
                  fill="none"
                  fill-rule="nonzero"
                  stroke="none"
                  stroke-width="1"
                  stroke-linecap="butt"
                  stroke-linejoin="miter"
                  stroke-miterlimit="10"
                  stroke-dasharray=""
                  stroke-dashoffset="0"
                  font-family="none"
                  font-weight="none"
                  font-size="none"
                  text-anchor="none"
                  style="mix-blend-mode: normal"
                >
                  <path d="M0,226v-226h226v226z" fill="none"></path>
                  <g fill="#b2b2b2">
                    <path
                      d="M82.80781,169.67656c1.05938,1.05937 2.47187,1.58906 3.70781,1.58906c1.23594,0 2.64844,-0.52969 3.70781,-1.58906l52.96875,-52.96875c2.11875,-2.11875 2.11875,-5.47344 0,-7.41563l-52.96875,-52.96875c-2.11875,-2.11875 -5.47344,-2.11875 -7.41563,0c-2.11875,2.11875 -2.11875,5.47344 0,7.41563l49.26094,49.26094l-49.26094,49.26094c-2.11875,2.11875 -2.11875,5.29688 0,7.41562z"
                    ></path>
                  </g>
                </g>
              </svg>
            </span>
            <span slot="next-nav">
              <svg
                class="page-arrow"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="22"
                height="22"
                viewBox="0 0 226 226"
                style="fill: #000000"
              >
                <g
                  fill="none"
                  fill-rule="nonzero"
                  stroke="none"
                  stroke-width="1"
                  stroke-linecap="butt"
                  stroke-linejoin="miter"
                  stroke-miterlimit="10"
                  stroke-dasharray=""
                  stroke-dashoffset="0"
                  font-family="none"
                  font-weight="none"
                  font-size="none"
                  text-anchor="none"
                  style="mix-blend-mode: normal"
                >
                  <path d="M0,226v-226h226v226z" fill="none"></path>
                  <g fill="#b2b2b2">
                    <path
                      d="M143.19219,56.32344c-2.11875,-2.11875 -5.47344,-2.11875 -7.41563,0l-52.96875,52.96875c-2.11875,2.11875 -2.11875,5.47344 0,7.41562l52.96875,52.96875c1.05937,1.05937 2.47188,1.58906 3.70781,1.58906c1.23594,0 2.64844,-0.52969 3.70781,-1.58906c2.11875,-2.11875 2.11875,-5.47344 0,-7.41563l-49.26094,-49.26094l49.26094,-49.26094c2.11875,-2.11875 2.11875,-5.29687 0,-7.41563z"
                    ></path>
                  </g>
                </g>
              </svg>
            </span>
          </pagination>
        </section>
      </div>
    </div>
  </div>
  <Loader v-else />
</template>

<script>
import DoubleLeftAroow from "../components/svgs/DoubleLeftAroow.vue";
import IndusturyFilter from "../components/main/IndusturyFilter.vue";
// import RateFilter from "../components/main/RateFilter.vue";
import BlogSliderFilter from "../components/main/BlogSliderFilter.vue";
import ArrowDown from "../components/svgs/ArrowDown.vue";
import HamburgetMenuIcon3 from "../components/svgs/HamburgetMenuIcon3.vue";
import HamburgerMenuIcon2 from "../components/svgs/HamburgerMenuIcon2.vue";
import Cardbox from "../components/main/CardboxBlog.vue";
import MenuIcon1 from "../components/svgs/menuIcon1.vue";
import MenuIcon2 from "../components/svgs/MenuIcon2.vue";
import CardBoxShow from "../components/main/CardBoxShow.vue";
import FilterIcon from "../components/svgs/FilterIcon.vue";
import SortResponsiveIcon from "../components/svgs/SortResponsiveIcon.vue";
import SearchIcon from "../components/svgs/SearchIcon.vue";
import SortResponsiveIcon1 from "../components/svgs/SortResponsiveIcon.vue";
import TelIcon from "../components/svgs/TelIcon.vue";
import SearchIconBlue from "../components/svgs/SearchIconBlue.vue";
import DropDownIconBlue from "../components/svgs/DropDownIconBlue.vue";
import blogVisitedImage from "../assets/images/blogvisitedimage.jpg";
import ClockIcon from "../components/svgs/ClockIcon.vue";
import FilterBox from "../components/main/FilterBox.vue";
import Loader from "../components/loader.vue";
export default {
  data() {
    return {
      search:"",
      selectedCategory: [],
      blogVisitedImage: blogVisitedImage,
      cardboxitems: 9,
      ShowingCard: false,
      CategoryItem: 20,
      ShowingBlogItem: true,
      blogdate: "۱۴۰۰/۱۱/۹ ",
      blogdesctext: "کسب عنوان «روابط عمومی برتر در حوزه اطلاع‌رسانی",
      VisitedBlogBox: 5,
      showfilterbox: false
    };
  },

  methods: {
    changePage(page) {
      let query = "?";
      if (this.selectedCategory.length > 0) {
        this.selectedCategory.forEach((id) => {
          query += `categoryIds[]=${id}&`;
        });
        query = query.substring(0, query.length - 1);
        query += `&page=${page}`;
        this.$axios.get("front/posts" + query).then((res) => {
          this.$store.commit("setBlogs", res.data.posts);
        });
      } else {
        query += `page=${page}`;
        this.$axios.get("front/posts" + query).then((res) => {
          this.$store.commit("setBlogs", res.data.posts);
        });
      }
    },
    getQuery() {
      let filters = {};

      if (this.$route.query.categoryIds) {
        filters.categoryIds = this.$route.query.categoryIds.split(",");
      }

      return filters;
    },
    getBlogs() {
      let filters = this.getQuery();
      let query = "";

      if (filters.categoryIds) {
        filters.categoryIds.forEach((id) => {
          query += `categoryIds[]=${id}&`;
        });
      }
      query = query.substring(0, query.length - 1);
      if (this.$route.query.page) {
        query += `&page=${this.$route.query.page}`;
      }
      this.$axios.get("front/posts?" + query).then((res) => {
        this.$store.commit("setBlogs", res.data.posts);
      });
    },
    fillOption() {
      let filters = this.getQuery();

      if (filters.categoryIds) {
        filters.categoryIds.forEach((id) => {
          this.selectedOption.categoryIds.push(id);
        });
      }
      if (filters.provinceIds) {
        filters.provinceIds.forEach((id) => {
          this.selectedOption.provinceIds.push(id);
        });
      }
      if (filters.cityIds) {
        filters.cityIds.forEach((id) => {
          this.selectedOption.cityIds.push(id);
        });
      }
      if (filters.countryIds) {
        filters.countryIds.forEach((id) => {
          this.selectedOption.countryIds.push(id);
        });
      }

      if (filters.townIds) {
        filters.townIds.forEach((id) => {
          this.selectedOption.townIds.push(id);
        });
      }
    },
    BlogBtn() {
      this.ShowingBlogItem = !this.ShowingBlogItem;
      var rotate = document.getElementById("DropDownIcon");
      rotate.classList.toggle("rotateIcon");
    },
    filter() {
      let query = "?";
      if (this.selectedCategory.length > 0) {
        this.selectedCategory.forEach((id) => {
          query += `categoryIds[]=${id}&`;
        });
        query = query.substring(0, query.length - 1);
        if (this.$route.query.page) {
          query += `&page=${this.$route.query.page}`;
        }
        if(this.search!=""){
          query += `&keyword=${this.search}`;

        }
      }else{
        if (this.$route.query.page) {
          query += `page=${this.$route.query.page}`;
        }else{
          query+="page=1"
        }
        if(this.search!=""){
          query += `&keyword=${this.search}`;

        }
      }
      this.$axios.get("front/posts" + query).then((res) => {
        this.$store.commit("setBlogs", res.data.posts);
        if(res.data.posts.data.length==0){
          this.$toast.warning(
          this.$root.globalData?this.$root.globalData.keys.not_found_any_blog_for_your_request_text:""
        );
        }
      });
    },
    HideFilter(flag) {
      this.showfilterbox = flag;
    },

    CardBoxShow() {}
  },
  components: {
    Loader,
    DoubleLeftAroow,
    IndusturyFilter,
    // RateFilter,
    BlogSliderFilter,
    ArrowDown,
    HamburgetMenuIcon3,
    HamburgerMenuIcon2,
    Cardbox,
    MenuIcon1,
    MenuIcon2,
    CardBoxShow,
    FilterIcon,
    SortResponsiveIcon,
    SearchIcon,
    SortResponsiveIcon1,
    TelIcon,
    SearchIconBlue,
    DropDownIconBlue,
    ClockIcon,
    FilterBox
  },

  computed: {
    blogs() {
      return this.$store.getters.getBlogs;
    },
    categories() {
      return this.$store.getters.getBlogCategories;
    }
  },
  mounted() {
    if (this.units == null || Object.keys(this.$route.query) != 0) {
      // let filter={}
      this.getBlogs();
    }
    this.fillOption();

    // https://gorgon.ir/v1/
    if (this.categories == null) {
      this.$axios.get("front/categories").then((res) => {
        this.$store.commit("setBlogsCategories", res.data.categories);
      });
    }
    //
  },
  
  metaInfo() {
        return { 
            title: "جزئیات پست",
            meta: [
                { name: 'description', content:  'جزئیات پست'},
                { property: 'og:title', content: "جزئیات پست"},
                {property: 'og:type', content: 'website'},    
                {name: 'robots', content: 'index,follow'} 
            ]
        }
    }
};
</script>

<style scoped>
.rotateIcon {
  transform: rotate(180deg);
}
.industury {
  background-color: #f1f0f0;
}
.industury__topbanner {
  width: 100%;
  height: 200px;
  background-image: url(../assets/images/industrybanner.jpg);
  background-color: rgba(0, 0, 0, 0.7);
  background-blend-mode: multiply;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

ul {
  display: flex;
  align-items: center;
  justify-content: center;
}

ul li {
  font-size: 20px;
  cursor: pointer;
}

.industury__body {
  padding: 2rem 0;
  display: grid;
  grid-template-columns: 1fr 350px;
  column-gap: 10px;
}
.industury__rightbox {
  padding: 1rem;
  order: 1;
}
.industury__leftbox {
  order: -1;
}

.dropdown__btnshow {
  background-color: #fff;
  padding: 10px;
  box-shadow: 0 0 10px gray;
  border-radius: 5px;
  margin: 10px;
  text-align: right;
}

.dropdown__btnshow select {
  width: 170px;
  outline: none;
  font-size: 14px;
}

.dropdown__btnshow select option {
  margin-top: 3rem;
  padding-top: 3rem;
}

.industury__show__right {
  display: flex;
  align-items: center;
}

.filter__btns span {
  cursor: pointer;
  padding: 8px 2px 1px;
  display: inline-block;
  margin: 5px;
  border-radius: 5px;
  background-color: #fff;
}

.active {
  background-color: #0d6efd !important;
}

.sortShowBtn {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.sortshow {
  text-align: right;
}

.industuty__setiing__responsive {
  display: none;
  /* background-color: red; */
  padding: 1rem 0;
  width: 100%;
}
.industuty__setiing__responsive .btn__setting {
  background-color: #fff;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  border-radius: 5px;
  box-shadow: 0 0 10px gray;
  flex-shrink: 1;
  cursor: pointer;
}
.industury__btn__setting__responsive .active {
  cursor: pointer;
  padding: 8px 2px 1px;
  display: inline-block;
  margin: 5px;
  border-radius: 5px;
}
.industury__btn__setting__responsive {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.industury__setting {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.industury__show__left {
  display: flex;
  align-items: center;
}

.industury__show__left button {
  background-color: #fff;
  padding: 10px 1rem;
  margin-right: 1rem;
  border-radius: 5px;
  box-shadow: 0 0 10px gray;
  cursor: pointer;
  font-size: 14px;
}

.industury__show__left p {
  margin-left: 10px;
  color: #0d6efd;
}

.industury__show__left .show {
  color: #0d6efd;
  padding: 5px;
}

.industury__cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  margin: 1rem 0;
}
.card__vertical {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
}

.blog__search {
  display: flex;
  background-color: #fff;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
}

.blog__search input {
  padding: 5px 0;
  flex-grow: 1;
  font-size: 15px;
  text-align:right;
  outline: none;
}
.blog__search span {
  cursor: pointer;
  display: flex;
}

.Blog__category__box {
  background-color: #fff;
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px;
  border-radius: 5px;
  cursor: pointer;
}
.Blog__category__box:active {
  box-shadow: 0 0 10px #ccc;
}

.blog__category__section {
  background-color: #fff;
  margin-top: 2px;
  height: 300px;
  overflow: scroll;
}

.blog__category__section::-webkit-scrollbar {
  display: none;
}
.blog__category__item {
  padding: 7px 10px;
  display: flex;
  justify-content: space-between;
}

.blog__category__item p {
  display: flex;
  align-items: center;
  font-size: 15px;
}
.blog__category__item input {
  margin-left: 10px;
}

.blog__category__item span {
  font-size: 13px;
}
.More__Blogs__Visited {
  margin: 2rem 0;
}

.More__Blogs__Visited h4 {
  text-align: right;
}

.blog__visited__box {
  display: flex;
  align-items: center;
  text-align: right;
  margin: 1rem 0;
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
}

.blog__visited__box img {
  width: 100px;
}
.blog__visited__box p {
  padding: 5px;
  font-size: 14px;
}
.blog__visited__box span {
  color: gray;
  padding: 5px;
}
.blog__desc p {
  margin-bottom: 1rem;
}

.blog__desc span {
  display: flex;
  align-items: center;
}

.pagination__section {
  width: 100%;
  padding: 1rem 0;
}

.pagination {
  display: flex;
  justify-content: center;
  flex-direction: row;
}
.pagination a {
  color: black;
  padding: 8px 16px;
  text-decoration: none;
  transition: background-color 0.3s;
}

.pagination a.active {
  background-color: dodgerblue;
  color: white;
}
.pagination a:hover:not(.active) {
  background-color: #ddd;
}

@media only screen and (max-width: 1155px) {
  .industury__topbanner {
    display: none;
  }

  .industury__rightbox {
    display: none;
  }
  .industury__body {
    grid-template-columns: 1fr;
  }
}
.w95{
  width: 95%;
}
@media only screen and (max-width: 768px) {
  .industury__setting {
    display: none;
  }

  .industuty__setiing__responsive {
    display: block;
    width: 95%;
  }
}

@media only screen and (max-width: 430px) {
  .industury__cards {
    grid-template-columns: 1fr;
    margin: 1rem 0;
  }
  .industury__btn__setting__responsive .btn__setting {
    font-size: 11px;
  }

  #cardBox {
  }
}
</style>

<style>
.ltrStyle .More__Blogs__Visited h4 {
  text-align: left;
}
.SearchIcon svg path {
  fill: #0d6efd;
}
.blogList {
  display: grid;
  direction: rtl;
  grid-template-columns: 1fr 1fr 1fr;
}
.blogList .card {
  transform: scale(0.9);
}
.blogList .card__address {
height: 70px;
    width: 300px;
    overflow: hidden;
    text-align: justify;
    direction: rtl;
}
.blogList .blogDetail {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  width: 100%;
  margin-bottom: -15px;
  color: black;;
  padding: 10px;
}
.blogList .blogDetail p {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
}
.blogList .card__title {
  height: 70px;
}
div#filterButtonBox button {
  padding: 10px 30px;
  background: #3d8bfd;
  color: white;
  border-radius: 5px;
}
#industury__body .unitsFilter {
  direction: rtl;
  background: white;
  margin-bottom: 10px;
}
</style>
